import {Component} from '@angular/core';
import {DUMMY_PROFILE_PIC} from "../constants/path.constants";
import {Language} from "../models/language";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss', './about-us-media.component.scss']
})
export class AboutUsComponent {
  lang: Language | undefined;
  protected readonly users = [
    [
      {
        profilePicture: DUMMY_PROFILE_PIC,
        fullName: 'John Doe',
        jobTitle: 'Developer'
      },
      {
        profilePicture: DUMMY_PROFILE_PIC,
        fullName: 'John Doe',
        jobTitle: 'Developer'
      },
      {
        profilePicture: DUMMY_PROFILE_PIC,
        fullName: 'John Doe',
        jobTitle: 'Developer'
      },
    ],
    [
      {
        profilePicture: DUMMY_PROFILE_PIC,
        fullName: 'John Doe',
        jobTitle: 'Developer'
      },
      {
        profilePicture: DUMMY_PROFILE_PIC,
        fullName: 'John Doe',
        jobTitle: 'Developer'
      },
      {
        profilePicture: DUMMY_PROFILE_PIC,
        fullName: 'John Doe',
        jobTitle: 'Developer'
      },
    ]
  ]
  currentLang: string = '';

  constructor(public translate: TranslateService) {
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  protected readonly Language = Language;
}
